import { Flex, LinkBox, LinkOverlay, Stack, Text } from '@chakra-ui/react';
import { WrappedImage } from '@time-line/components/common';
import NextLink from 'next/link';
import type { TimelineEvent } from 'types/cms/blocks/Timeline';

export const CARD_WIDTH = 228;

export function TimelineCard({ category, title, image, link }: TimelineEvent) {
  return (
    <LinkBox
      role="group"
      as={Flex}
      flexDirection="column"
      userSelect="none"
      w={`${CARD_WIDTH}px`}
      transition="transform 0.2s ease"
      _hover={{ transform: link ? 'scale(0.95)' : undefined }}
    >
      <Stack
        bg="gray.50"
        border="1px solid"
        borderColor="blackAlpha.250"
        borderRadius="lg"
        p="4xs"
        spacing="4xs"
        w="100%"
      >
        <Stack py="5xs" px="4xs" spacing="2px">
          <Text
            color="blackAlpha.700"
            size="detail"
            fontWeight="medium"
            textTransform="capitalize"
          >
            {category}
          </Text>
          <Text size="title3" as="h2">
            {link ? (
              <LinkOverlay as={NextLink} href={link}>
                {title}
              </LinkOverlay>
            ) : (
              <>{title}</>
            )}
          </Text>
        </Stack>
        {image && (
          <WrappedImage alt={title} image={image} sizes="230px" ratio={3 / 2} />
        )}
      </Stack>
    </LinkBox>
  );
}
